import intro from 'images/modals/onboarding/onboarding_1.png';
import contentPlanning from 'images/modals/onboarding/onboarding_2.png';
import contentDiscovery from 'images/modals/onboarding/onboarding_3.png';
import searchFind from 'images/modals/onboarding/onboarding_4.png';
import deepDive from 'images/modals/onboarding/onboarding_5.png';
import personalize from 'images/modals/onboarding/onboarding_6.png';
import outro from 'images/modals/onboarding/onboarding_7.png';

const imageMap = {
  intro,
  contentPlanning,
  contentDiscovery,
  searchFind,
  deepDive,
  personalize,
  outro,
};

export default [
  {
    title: 'Welcome to Blueprint',
    content: 'We’ve been hard at work building the next major version of the Knotch Blueprint product, and are happy to share' +
    ' it with you. With this new version, we’re bringing all of your content planning under one roof, including competitor content analysis, ' +
    'for a data-driven content marketing program and distribution strategy.',
    image: imageMap.intro,
    imagePosition: '0 0',
    imageSize: 'auto 100%',
    btnText: '→',
  },
  {
    title: 'Ultimate Content Planning',
    content: 'Blueprint 2.0 is the first content planning product that allows you to see content from every brand and '
    + 'publisher, across owned and paid channels. Easily identify the brands putting out great content, and then up-your-game to surpass them. ' +
    'Blueprint does the heavy lifting so you can focus on making strategic content decisions.',
    image: imageMap.contentPlanning,
    imagePosition: '80px 60px',
    imageSize: 'auto 100%',
    btnText: '→',
  },
  {
    title: 'Automated Content Discovery',
    content: 'Don’t waste hours on the internet trying to hunt down content from brands, competitors, and publishers across' +
    ' the internet. The Blueprint library automatically surfaces all of this content for you.',
    image: imageMap.contentDiscovery,
    imagePosition: '20px 30px',
    imageSize: 'auto 100%',
    btnText: '→',
  },
  {
    title: 'Don’t Just Search, Find',
    content: 'Use advanced search & filters to drill down to the content that’s most important to you. Identify popular themes' +
    ', formats, keywords, and unlock new content marketing opportunities.',
    image: imageMap.searchFind,
    imagePosition: '20px 30px',
    imageSize: 'auto 100%',
    btnText: '→',
  },
  {
    title: 'Deep-Dive Into Content',
    content: 'Use advanced search & filters to drill down to the content that’s most important to you. Identify popular themes' +
    ', formats, keywords, and unlock new content marketing opportunities.',
    image: imageMap.deepDive,
    imagePosition: '80px 80px',
    imageSize: 'auto 100%',
    btnText: '→',
  },
  {
    title: 'Personalize your Blueprint',
    content: 'Add Competitors or Subscribe to the brands and publishers that you want to keep track of and we’ll automatically' +
    ' create a custom Competitor library & personalise your home page to feature all of their latest content too.' +
    ' You can do this from your home page or from any brand or publisher profile page.',
    image: imageMap.personalize,
    imagePosition: '100px 70px',
    imageSize: 'auto 100%',
    btnText: '→',
  },
  {
    title: 'We hope you love using Blueprint as much as we do.',
    content: '',
    image: imageMap.outro,
    imagePosition: 'center center',
    imageSize: '80px auto',
    btnText: 'Get Started',
  },
];
